import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksStaffGroups(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].getRegulationsStagesPlanWorksStaffGroups,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksStaffGroupPreview(companyId, regulationId, stageId, planWorkId, staffGroupsId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].getRegulationsStagesPlanWorksStaffGroupPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				staffGroupsId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksStaffGroupPopup(companyId, regulationId, stageId, planWorkId, staffGroupsId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].getRegulationsStagesPlanWorksStaffGroupPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				staffGroupsId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksStaffGroup(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].createRegulationsStagesPlanWorksStaffGroup, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksStaffGroup(companyId, regulationId, stageId, planWorkId, staffGroupsId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].getRegulationsStagesPlanWorksStaffGroup, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffGroupsId,
		},
	})
}

function patchRegulationsStagesPlanWorksStaffGroup(companyId, regulationId, stageId, planWorkId, staffGroupsId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].patchRegulationsStagesPlanWorksStaffGroup, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffGroupsId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksStaffGroup(companyId, regulationId, stageId, planWorkId, staffGroupsId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].putRegulationsStagesPlanWorksStaffGroup, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffGroupsId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksStaffGroup(companyId, regulationId, stageId, planWorkId, staffGroupsId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].deleteRegulationsStagesPlanWorksStaffGroup, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffGroupsId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksStaffGroups,
	getRegulationsStagesPlanWorksStaffGroupPopup,
	getRegulationsStagesPlanWorksStaffGroupPreview,
	getRegulationsStagesPlanWorksStaffGroup,
	patchRegulationsStagesPlanWorksStaffGroup,
	putRegulationsStagesPlanWorksStaffGroup,
	createRegulationsStagesPlanWorksStaffGroup,
	deleteRegulationsStagesPlanWorksStaffGroup,
}
